/**
 * Enumeração dos tipos de toasts disponíveis para exibição
 */
export enum ToastType {
  ERROR = 'error',
  WARNING = 'warning',
  QUESTION = 'question',
  INFO = 'info',
  SUCESS = 'success',
}
